import React from "react";

import Icon from "@cayuse/shared-react.components.icon";

import { toggle } from "../utils/personSearch";
import styles from "./styles.css";

export const ExpandOption = ({ expandRef }) => {
	const handleClick = event => {
		if (event.target.textContent === "Collapse All" || event.target.id === "expnded") {
			toggle(expandRef.current, false);
		} else if (event.target.textContent === "Expand All"  || event.target.id === "collapsed") {
			toggle(expandRef.current, true);
		}
		event.stopPropagation();
	};

	return (
		<div className={styles.optionContent} ref={expandRef} onClick={handleClick}>
			<Icon id="collapsed" name="chevron-right"/>
			<span className="person-search-expand-label">Expand All</span>
		</div>
	);
};
